import { AdminPayments } from '../model/adminPayments';
export class AdminPaymentsBuilder {
    static buildAdminPayments(data) {
        let p = new AdminPayments();
        p.id = data.id;
        p.id_via = data.id_via;
        p.id_user = data.id_user;
        p.id_shift = data.id_shift;
        p.id_reservation = data.id_reservation;
        p.id_profile = data.id_profile;
        p.id_paymethod = data.id_paymethod;
        p.amount = data.amount;
        p.error = data.error;
        p.result = data.result;
        p.timestamp = data.timestamp;
        p.paymethod_type = data.paymethod_type;
        p.paymethod_alias = data.paymethod_alias;
        p.paymethod_provider = data.paymethod_provider;
        p.paymethod_id_client = data.paymethod_id_client;
        p.paymethod_id_company = data.paymethod_id_company;
        p.id_lot = data.id_lot;
        p.id_product = data.id_product;
        return p;
    }
}
//# sourceMappingURL=adminPayments-builder.js.map